<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { error, errorLog, getToken, warning } from "@/utils";
import { computed, ref } from "vue";

const props = defineProps<{ maximize: number }>();
const emit = defineEmits(["remove", "success"]);
const refUpload = ref();

const headers = { token: getToken() };
const apiUpload = computed(() => `/api/File/Upload`);
const uploadMaximize = computed(() => props.maximize * 1024);

function onSuccess({
  responseText,
}: {
  responseText: { statusCode: number; errMsg: string; data: string };
  fileItem: any;
}) {
  if (responseText.statusCode !== 200) return;
  const result = JSON.parse(responseText.data);
  if (!result.success) return;
  emit("success", { returnFile: result.data });
}

function onDelete({ files, fileList, index }: any) {
  console.log(files, fileList, index);
}

function onFailure({ responseText }: { responseText: string }) {
  errorLog(responseText);
  error("图片上传出错了，请联系管理员");
}

function onOversize() {
  warning(`文件大小不能超过${props.maximize}KB`);
}

function clearFiles() {
  refUpload.value.clearUploadQueue();
}

defineExpose({ clearFiles });
</script>
<template>
  <nut-uploader
    ref="refUpload"
    v-bind="$attrs"
    :url="apiUpload"
    :headers="headers"
    :maximize="uploadMaximize"
    @success="onSuccess"
    @delete="onDelete"
    @failure="onFailure"
    @oversize="onOversize"
  >
    <template #default v-if="$slots.default">
      <slot name="default" />
    </template>
    <template #upload-icon v-if="$slots['upload-icon']">
      <slot name="upload-icon" />
    </template>
    <template #delete-icon v-if="$slots['delete-icon']">
      <slot name="delete-icon" />
    </template>
  </nut-uploader>
</template>
